import { addApoFeatures } from '@actions/apo.action';
import { inject, Injectable } from '@angular/core';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import { Store } from '@ngrx/store';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { RudderStackService } from '@services/rudderstack/rudderstack.service';

@Injectable({
  providedIn: 'root',
})
export class ApoService {

  private gbs: GrowthBookService = inject(GrowthBookService);
  private store = inject(Store);
  private rss: RudderStackService = inject(RudderStackService);

  readonly apoFeatures: string[] = [
    'feat_001888_ndp_fare_price_vs_competitors',
    'test_feature_apo',
    GrowthBookFeatureKeys.FEAT_US929_CB10_INCLUDED_WITH_ECONOMY_LIGHT,
    GrowthBookFeatureKeys.FEAT_US930_FREE_SEAT_PREMIUM_CLASSIC,
    'feat_000000_ndp_rtd_flag',
    'feat_001904_seat_price_test_v2',
    'feat-002261-price-delta-sensitivity',
    'feat-002262-price-delta-sensitivity',
    'feat_001903_bag_price_test',
    'feat_002114_premium_pricing',
    'feat_002449_middle_seat_price_test',
    'feat-ndp-2797-premium-diff-to-economy-lf-balancing',
    'feat_002910_increase_round_trip_profitability',
    'feat_002880_premium_middle_seat_price_increase',
    'feat_003290_premium_cabin_seat_price_test',
    'feat-003405-bags-price-99',
    'feat-003406-meals-price-99',
    'feat-003407-extras-price-99'
  ];

  addApos() {
    const anonId = this.rss.getAnonymousId();
    const inputParams: Record<string, string> = {};
    inputParams['anonymous_id'] = anonId ?? '';
    this.apoFeatures.map(
      (featureKey) => inputParams[featureKey.replace(/-/g,'_')] = this.getFeatureValue(featureKey, ''),
    );
    this.store.dispatch(
      addApoFeatures({
        features: inputParams,
      }),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private getFeatureValue(featureKey: any, defaultValue: string): string {
    return this.gbs.growthBook.getFeatureValue(featureKey, defaultValue);
  }
}
